import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import apiClient, { formatApiError } from '../utils/api';
import { toast } from 'sonner';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await apiClient.post('/auth/forgot-password', { email });
      setSent(true);
    } catch (error) {
      toast.error(formatApiError(error));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#f5f0e8] flex items-center justify-center p-4" data-testid="forgot-password-page">
      <div className="max-w-md w-full bg-white border border-[#c5d4c8] rounded-xl p-8 shadow-sm">
        <h1 className="text-2xl font-bold text-[#2d2a26] mb-1">Reset password</h1>
        <p className="text-sm text-[#6b665c] font-mono mb-6">We'll email you a reset link.</p>

        {sent ? (
          <div className="space-y-4" data-testid="forgot-password-sent">
            <div className="bg-green-50 border border-green-200 text-green-800 rounded p-4 text-sm">
              If an account exists for <strong>{email}</strong>, we've sent a password-reset link. Check your inbox (and spam folder) within the next hour.
            </div>
            <Button onClick={() => navigate('/login')} className="w-full bg-blue-600 hover:bg-blue-700 text-white" data-testid="back-to-login-btn">
              Back to login
            </Button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4" data-testid="forgot-password-form">
            <div>
              <Label className="font-mono text-xs uppercase tracking-wider text-[#5a6e5f]">Email</Label>
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="mt-2 bg-[#f5f0e8] border-[#c5d4c8] text-[#2d2a26]"
                data-testid="forgot-email-input"
              />
            </div>
            <Button type="submit" disabled={loading} className="w-full bg-blue-600 hover:bg-blue-700 text-white" data-testid="send-reset-btn">
              {loading ? 'Sending…' : 'Send reset link'}
            </Button>
            <button type="button" onClick={() => navigate('/login')} className="w-full text-xs text-[#5a6e5f] font-mono hover:text-[#3f5246]" data-testid="cancel-forgot-btn">
              Cancel
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
